import { HttpService } from "core/services/http";
import { Utils } from "core/utils";
import useProfile from "features/feature_user/hooks/UseProfile";
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Route component that only allows access to users with employer role
 * Redirects to home page if user is not an employer
 * Checks both localStorage user.role and profile.role
 */
const EmployerRoute = ({ children }) => {
    const token = HttpService.getToken();
    const { data: profile, isLoading } = useProfile({ enabled: !!token });
    
    // Check role from localStorage (updated by UseProfile hook) or profile
    const role = Utils.getUserRole() || profile?.role;
    const isEmployer = !!token && role === 'employer';
    
    // Show loading state while profile is being fetched
    if (isLoading && token) {
        return null; // or a loading spinner
    }
    
    if (!isEmployer) {
        // Redirect to home page if not an employer
        return <Navigate to="/" replace />;
    }
    
    return children;
};

export default EmployerRoute;
